/**
 * Spread these props onto an AntD <Button icon={…}> for the small square 32×32
 * icon buttons used across action rows (Workflows cards, Version History table,
 * Workflow Details). Keeps the visual rhythm consistent and stops the constants
 * from drifting one screen at a time.
 */
export const ICON_BTN_PROPS = {
  size: 'small',
  style: { borderRadius: 8, padding: 0, width: 32, height: 32, fontSize: 14 },
} as const;
